<template>
  <footer class="hidden h-footer justify-between bg-emo-black px-6 text-white md:flex">
    <div class="flex items-center">
      <div class="flex items-center gap-4">
        <router-link :to="textVersionButtonContent.routePath">
          <button class="flex h-8 items-center gap-1 rounded-[4px] border border-white px-2">
            <gv-icon :name="textVersionButtonContent.icon" class="fill-white" />
            <div>{{ textVersionButtonContent.content }}</div>
          </button>
        </router-link>
        <nav class="flex">
          <div v-for="(appRoute, index) in footerRoutes" :key="appRoute.title" class="flex">
            <ui-footer-nav-item v-if="appRoute.routeType == 'internal'" :link="appRoute.link" :title="appRoute.title" />
            <a v-else-if="appRoute.routeType == 'external'" class="underline" :href="appRoute.link" target="_blank" external>{{
              appRoute.title
            }}</a>
            <div v-if="index !== footerRoutes.length - 1" class="mx-4 h-6 w-px bg-emo-mid-grey" />
          </div>
          <div class="mx-4 h-6 w-px bg-emo-mid-grey" />
          <ui-language-dropdown />
        </nav>
      </div>
    </div>

    <div class="flex items-center">
      <a href="https://www.gov.mb.ca/index.html" target="_blank">
        <img src="@/common/assets/logos/manitoba-government-logo.png" :alt="t('C8vUemFpTH3cavAdPjofJ')" class="h-4" />
      </a>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n();
const route = useRoute();

const textVersionButtonContent = computed(() => {
  if (route.fullPath.startsWith('/text-version')) {
    return {
      content: t('lguL1fqTJzX7folpDEoBI'),
      icon: 'web',
      routePath: '/',
    };
  }
  return {
    content: t('worQ16AQn448N1wCt-tLQ'),
    icon: 'abc',
    routePath: '/text-version',
  };
});

const footerRoutes = computed(() => {
  return [
    {
      title: t('1a7LOuqd0nGD2JxQBAq2-'),
      link: '/about',
      routeType: 'internal',
    },
    {
      title: t('cVpCn6Y4HFbwfn92yjYSb'),
      link: '/about#disclaimer',
      routeType: 'internal',
    },
  ];
});
</script>
